module.exports = __webpack_public_path__ + "img/generic-empty-state.5de03f29.svg";